import { defineMessages } from 'react-intl';

export default defineMessages({
    limit: {
        id: 'ml.quoteandbind.valuableItemsUnspecified.limit',
        defaultMessage: 'Total Limit'
    },
    type: {
        id: 'ml.quoteandbind.valuableItemsUnspecified.type',
        defaultMessage: 'Item Type'
    },
    action: {
        id: 'ml.quoteandbind.valuableItemsUnspecified.action',
        defaultMessage: 'Action'
    },
    addBtn: {
        id: 'ml.quoteandbind.valuableItemsUnspecified.addBtn',
        defaultMessage: 'Add'
    },
    edit: {
        id: 'ml.quoteandbind.valuableItemsUnspecified.edit',
        defaultMessage: 'Edit'
    },
    remove: {
        id: 'ml.quoteandbind.valuableItemsUnspecified.remove',
        defaultMessage: 'Remove'
    }
});